import { render, staticRenderFns } from "./PlanBanner.vue?vue&type=template&id=681d1b27&"
import script from "./PlanBanner.vue?vue&type=script&lang=js&"
export * from "./PlanBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports